import { openMiniEditor } from '../../MiniEditor';
import PaymentList from '../../New/Components/PaymentList';

export default (formId: string) => {
  return new Promise((resolve) =>
    openMiniEditor({
      formId,
      title: "Ödeme Düzenle",
      children: (
        <div style={{ width: "50vw" }}>
          <PaymentList />
        </div>
      ),
      onClosed: resolve,
    })
  );
};
